import { useState } from "react";
import { Tag, X } from "lucide-react";
import { http, euro } from "@/lib/api";

export const CouponField = ({ email, subtotal, coupon, setCoupon }) => {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const apply = async () => {
    setErr("");
    if (!email) return setErr("Renseignez d'abord votre email.");
    setBusy(true);
    try {
      const { data } = await http.post("/coupons/validate", { code, email, subtotal });
      setCoupon(data);
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Code invalide.");
    } finally {
      setBusy(false);
    }
  };

  if (coupon)
    return (
      <div data-testid="coupon-applied" className="flex items-center justify-between rounded-xl bg-[var(--bone-2)] px-4 py-3 text-sm">
        <span className="flex items-center gap-2"><Tag className="h-4 w-4 text-[var(--terra)]" />{coupon.code} · {coupon.label}</span>
        <span className="flex items-center gap-3">-{euro(coupon.discount)}
          <button type="button" data-testid="coupon-remove-button" onClick={() => setCoupon(null)} aria-label="Retirer le code"><X className="h-4 w-4" /></button>
        </span>
      </div>
    );

  return (
    <div>
      <div className="flex gap-2">
        <input data-testid="coupon-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="Code promo (ex. BIENVENUE10)"
          className="min-w-0 flex-1 rounded-xl border border-[var(--line)] bg-white px-4 py-3 text-sm outline-none focus:border-[var(--ink)]" />
        <button type="button" data-testid="coupon-apply-button" onClick={apply} disabled={!code || busy}
          className="rounded-xl border border-[var(--ink)] px-4 text-sm transition-colors hover:bg-[var(--ink)] hover:text-[var(--bone)] disabled:opacity-50">
          Appliquer
        </button>
      </div>
      {err && <p data-testid="coupon-error" className="mt-1.5 text-xs text-[var(--terra-deep)]">{err}</p>}
    </div>
  );
};
